<div [ngClass]="{'horizontal-thumbnail': orientation == 'horizontal'}" *ngFor="let thumb of images">
    <ee-product-image alt="thumbnail"
                     width="38"
                     height="38"
                     (click)="onClick(thumb)"
                     [ngClass]="{'active': thumb == activeImage}"
                     [src]="thumb.thumb"></ee-product-image>
</div>
